export const YBL_DOWNTIME_FORM_CONFIG = [
  {
    key: 'description',
    name: 'description',
    label: 'Description',
    placeholder: 'Enter description',
    fieldType: 'input',
    inputType: 'text',
    isEditable: true,
    isRequired: true
  },
  {
    key: 'partner',
    name: 'Partner',
    label: 'Partner',
    placeholder: 'Select Partner',
    fieldType: 'select',
    isRequired: true
  },
  {
    key: 'rail',
    name: 'rail',
    label: 'Transfer Type',
    placeholder: 'Select Transfer Type',
    fieldType: 'select',
    isRequired: true
  },
  {
    key: 'startTime',
    name: 'startTime',
    label: 'Start Time',
    placeholder: 'Select start time',
    fieldType: 'input',
    inputType: 'datetime-local',
    isEditable: true,
    isRequired: true
  },
  {
    key: 'endTime',
    name: 'endTime',
    label: 'End Time',
    placeholder: 'Select end time',
    fieldType: 'input',
    inputType: 'datetime-local',
    isEditable: true,
    isRequired: true
  },
  {
    key: 'isActive',
    name: 'isActive',
    label: 'isActive',
    fieldType: 'select',
    options: [
      { value: 'true', label: 'True' },
      { value: 'false', label: 'False' }
    ],
    isEditable: true,
    isRequired: true
  }
]; 